import { useCallback } from 'react'
import { COMPETITIONS_BOTTOM_BAR_CONFIG } from '../../config/competitionsBottomBarConfig'
import { useBrowerStorage } from '../useBrowserStorage'

export const EMPTY_ARRAY = []
export const IGNORED_LIVE_MATCH_VALIDATION = (x: any) =>
    Array.isArray(x) && x.every((v) => typeof v === 'number')

export const useIgnoredMobileLiveMatch = (): {
    ignoredLiveMatch: number[]
    addIgnoredLiveMatch: (x: number) => void
} => {
    const { value: ignoredLiveMatch, setValue: setIgnoredLiveMatch } = useBrowerStorage<number[]>({
        key: COMPETITIONS_BOTTOM_BAR_CONFIG.IGNORED_MOBILE_LIVE_MATCH.LOCAL_STORAGE_KEY,
        defaultValue: EMPTY_ARRAY,
        getItemValidation: IGNORED_LIVE_MATCH_VALIDATION,
    })

    const addIgnoredLiveMatch = useCallback(
        (postId: number) => {
            setIgnoredLiveMatch(
                (old) =>
                    [postId, ...old]
                        .filter((x, index, arr) => arr.indexOf(x) === index) // remove the duplicates
                        .slice(
                            0,
                            COMPETITIONS_BOTTOM_BAR_CONFIG.IGNORED_MOBILE_LIVE_MATCH.MAX_ITEMS,
                        ), // We assume that we have never more than 10 match in live, to avoid array to grow without limit
            )
        },
        [setIgnoredLiveMatch],
    )

    return { ignoredLiveMatch, addIgnoredLiveMatch }
}
